module.exports = __webpack_public_path__ + "img/homepage2_02-administracion-de-riesgos.5c5cdcb1.jpg";